import React, { useState } from 'react'

import {
    Card,
    CardHeader,
    CardContent,
    Box,
    Typography,
    TextField,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Button,
    Grid,
} from '@mui/material'
import { 
    Build,
    Add as Plus,
    Upload
 } from '@mui/icons-material'
import { useTheme } from '@mui/material/styles'
import { useSelector } from 'react-redux'
import { RootState } from '../../store'
import { MaintenanceRequestForm } from '../../types/serviceRequest'
import { ServiceRequestImage } from './ServiceRequestImage'

interface Props {
    handleSubmitRequest: (e: React.FormEvent) => void
    newRequest: MaintenanceRequestForm
    setNewRequest: (newRequest: MaintenanceRequestForm) => void
    isSubmitting: boolean
    tenantImage: File | null
    setTenantImage: (image: File | null) => void
}

export const SubmitNewRequest = (props: Props) => {
    const { handleSubmitRequest, newRequest, setNewRequest, isSubmitting, tenantImage, setTenantImage } = props
    const theme = useTheme()
    const selectedLease = useSelector(
        (state: RootState) => state.lease.selectedLease,
    )


    
    return (
        <Card
            sx={{
                width: 'calc(100% - 48px)',
                maxWidth: '800px',
                bgcolor: 'rgba(138, 142, 140, 0.16)',
                borderRadius: 2,
                boxShadow: 'none',
                border: '1px solid rgba(255,255,255,0.1)',
            }}
        >
            <CardHeader
                title={
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Plus
                            sx={{ mr: 1, color: theme.palette.primary.main }}
                        />
                        <Typography
                            variant="h6"
                            sx={{ color: 'rgba(255,255,255,0.8)' }}
                        >
                            Submit New Maintenance Request
                        </Typography>
                    </Box>
                }
            />
            <CardContent>
                {selectedLease?.apartment_allow_service_request === false ? (
                    <Box
                        sx={{
                            textAlign: 'center',
                            py: 4,
                            px: 2,
                        }}
                    >
                        <Build
                            sx={{
                                fontSize: 48,
                                color: 'rgba(255,255,255,0.5)',
                                mb: 2,
                            }}
                        />
                        <Typography
                            variant="h6"
                            sx={{
                                color: 'rgba(255,255,255,0.8)',
                                mb: 1,
                            }}
                        >
                            Service Requests Not Available
                        </Typography>
                        <Typography
                            sx={{
                                color: 'rgba(255,255,255,0.6)',
                                maxWidth: '600px',
                                mx: 'auto',
                            }}
                        >
                            This apartment community does not currently allow
                            tenants to submit service requests through the
                            portal. Please contact your property manager or
                            leasing office directly to report maintenance
                            issues.
                        </Typography>
                    </Box>
                ) : (
                    <form onSubmit={handleSubmitRequest}>
                        <Grid container spacing={3}>
                            {/* Issue Title */}
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    required
                                    label="Issue Title"
                                    value={newRequest.title}
                                    onChange={(e) =>
                                        setNewRequest({
                                            ...newRequest,
                                            title: e.target.value,
                                        })
                                    }
                                    placeholder="Brief description of the issue"
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            color: 'rgba(255,255,255,0.8)',
                                            '& fieldset': {
                                                borderColor:
                                                    'rgba(255,255,255,0.2)',
                                            },
                                            '&:hover fieldset': {
                                                borderColor:
                                                    'rgba(255,255,255,0.3)',
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor:
                                                    theme.palette.primary.main,
                                            },
                                        },
                                        '& .MuiInputLabel-root': {
                                            color: 'rgba(255,255,255,0.5)',
                                            '&.Mui-focused': {
                                                color: theme.palette.primary
                                                    .main,
                                            },
                                        },
                                    }}
                                />
                            </Grid>

                            {/* Category */}
                            {/* <Grid item xs={12} md={6}>
                                <FormControl fullWidth required>
                                    <InputLabel
                                        sx={{
                                            color: 'rgba(255,255,255,0.5)',
                                            '&.Mui-focused': {
                                                color: theme.palette.primary
                                                    .main,
                                            },
                                        }}
                                    >
                                        Category
                                    </InputLabel>
                                    <Select
                                        value={newRequest.category}
                                        label="Category"
                                        onChange={(e) =>
                                            setNewRequest({
                                                ...newRequest,
                                                category: e.target.value,
                                            })
                                        }
                                        sx={{
                                            color: 'rgba(255,255,255,0.8)',
                                            '& .MuiOutlinedInput-notchedOutline':
                                                {
                                                    borderColor:
                                                        'rgba(255,255,255,0.2)',
                                                },
                                            '&:hover .MuiOutlinedInput-notchedOutline':
                                                {
                                                    borderColor:
                                                        'rgba(255,255,255,0.3)',
                                                },
                                            '&.Mui-focused .MuiOutlinedInput-notchedOutline':
                                                {
                                                    borderColor:
                                                        theme.palette.primary
                                                            .main,
                                                },
                                            '& .MuiSvgIcon-root': {
                                                color: 'rgba(255,255,255,0.5)',
                                            },
                                        }}
                                    >
                                        <MenuItem value="plumbing">
                                            Plumbing
                                        </MenuItem>
                                        <MenuItem value="electrical">
                                            Electrical
                                        </MenuItem>
                                        <MenuItem value="hvac">HVAC</MenuItem>
                                        <MenuItem value="appliances">
                                            Appliances
                                        </MenuItem>
                                        <MenuItem value="hardware">
                                            Hardware/Locks
                                        </MenuItem>
                                        <MenuItem value="flooring">
                                            Flooring
                                        </MenuItem>
                                        <MenuItem value="painting">
                                            Painting
                                        </MenuItem>
                                        <MenuItem value="other">Other</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid> */}

                            {/* Priority Level */}
                            {/* <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <InputLabel
                                        sx={{
                                            color: 'rgba(255,255,255,0.5)',
                                            '&.Mui-focused': {
                                                color: theme.palette.primary
                                                    .main,
                                            },
                                        }}
                                    >
                                        Priority Level
                                    </InputLabel>
                                    <Select
                                        value={newRequest.priority}
                                        label="Priority Level"
                                        onChange={(e) =>
                                            setNewRequest({
                                                ...newRequest,
                                                priority: e.target.value as "low" | "medium" | "high" | "emergency",
                                            })
                                        }
                                        sx={{
                                            color: 'rgba(255,255,255,0.8)',
                                            '& .MuiOutlinedInput-notchedOutline':
                                                {
                                                    borderColor:
                                                        'rgba(255,255,255,0.2)',
                                                },
                                            '&:hover .MuiOutlinedInput-notchedOutline':
                                                {
                                                    borderColor:
                                                        'rgba(255,255,255,0.3)',
                                                },
                                            '&.Mui-focused .MuiOutlinedInput-notchedOutline':
                                                {
                                                    borderColor:
                                                        theme.palette.primary
                                                            .main,
                                                },
                                            '& .MuiSvgIcon-root': {
                                                color: 'rgba(255,255,255,0.5)',
                                            },
                                        }}
                                    >
                                        <MenuItem value="low">
                                            Low - Cosmetic/Non-urgent
                                        </MenuItem>
                                        <MenuItem value="medium">
                                            Medium - Normal maintenance
                                        </MenuItem>
                                        <MenuItem value="high">
                                            High - Affects daily living
                                        </MenuItem>
                                        <MenuItem value="emergency">
                                            Emergency - Immediate attention
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid> */}

                            {/* Location in Unit */}
                            {/* <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label="Location in Unit"
                                    value={newRequest.location}
                                    onChange={(e) =>
                                        setNewRequest({
                                            ...newRequest,
                                            location: e.target.value,
                                        })
                                    }
                                    placeholder="e.g., Kitchen, Master Bedroom, Living Room"
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            color: 'rgba(255,255,255,0.8)',
                                            '& fieldset': {
                                                borderColor:
                                                    'rgba(255,255,255,0.2)',
                                            },
                                            '&:hover fieldset': {
                                                borderColor:
                                                    'rgba(255,255,255,0.3)',
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor:
                                                    theme.palette.primary.main,
                                            },
                                        },
                                        '& .MuiInputLabel-root': {
                                            color: 'rgba(255,255,255,0.5)',
                                            '&.Mui-focused': {
                                                color: theme.palette.primary
                                                    .main,
                                            },
                                        },
                                    }}
                                />
                            </Grid> */}

                            {/* Description */}
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    required
                                    multiline
                                    rows={4}
                                    label="Detailed Description"
                                    value={newRequest.description}
                                    onChange={(e) =>
                                        setNewRequest({
                                            ...newRequest,
                                            description: e.target.value,
                                        })
                                    }
                                    placeholder="Please provide detailed information about the issue, including when it started and any relevant circumstances"
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            color: 'rgba(255,255,255,0.8)',
                                            '& fieldset': {
                                                borderColor:
                                                    'rgba(255,255,255,0.2)',
                                            },
                                            '&:hover fieldset': {
                                                borderColor:
                                                    'rgba(255,255,255,0.3)',
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor:
                                                    theme.palette.primary.main,
                                            },
                                        },
                                        '& .MuiInputLabel-root': {
                                            color: 'rgba(255,255,255,0.5)',
                                            '&.Mui-focused': {
                                                color: theme.palette.primary
                                                    .main,
                                            },
                                        },
                                    }}
                                />
                            </Grid>

                            {/* Preferred Visit Time */}
                            {/* <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel
                                        sx={{
                                            color: 'rgba(255,255,255,0.5)',
                                            '&.Mui-focused': {
                                                color: theme.palette.primary
                                                    .main,
                                            },
                                        }}
                                    >
                                        Preferred Visit Time
                                    </InputLabel>
                                    <Select
                                        value={newRequest.preferredTime}
                                        label="Preferred Visit Time"
                                        onChange={(e) =>
                                            setNewRequest({
                                                ...newRequest,
                                                preferredTime: e.target.value,
                                            })
                                        }
                                        sx={{
                                            color: 'rgba(255,255,255,0.8)',
                                            '& .MuiOutlinedInput-notchedOutline':
                                                {
                                                    borderColor:
                                                        'rgba(255,255,255,0.2)',
                                                },
                                            '&:hover .MuiOutlinedInput-notchedOutline':
                                                {
                                                    borderColor:
                                                        'rgba(255,255,255,0.3)',
                                                },
                                            '&.Mui-focused .MuiOutlinedInput-notchedOutline':
                                                {
                                                    borderColor:
                                                        theme.palette.primary
                                                            .main,
                                                },
                                            '& .MuiSvgIcon-root': {
                                                color: 'rgba(255,255,255,0.5)',
                                            },
                                        }}
                                    >
                                        <MenuItem value="morning">
                                            Morning (8 AM - 12 PM)
                                        </MenuItem>
                                        <MenuItem value="afternoon">
                                            Afternoon (12 PM - 5 PM)
                                        </MenuItem>
                                        <MenuItem value="evening">
                                            Evening (5 PM - 8 PM)
                                        </MenuItem>
                                        <MenuItem value="anytime">
                                            Anytime
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid> */}

                            {/* Upload Photos */}
                            <Grid item xs={12}>
                                <Box
                                    sx={{
                                        p: 3,
                                        border: '2px dashed',
                                        borderColor: 'rgba(255,255,255,0.1)',
                                        borderRadius: 1,
                                        textAlign: 'center',
                                    }}
                                >
                                    <ServiceRequestImage
                                        index={0}
                                        image={tenantImage}
                                        setImage={(image) => setTenantImage(image)}
                                    />
                                </Box>
                            </Grid>

                            <Grid item xs={12}>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    fullWidth
                                    size="large"
                                    disabled={isSubmitting}
                                    sx={{
                                        bgcolor: theme.palette.primary.main,
                                        color: 'white',
                                        '&:hover': {
                                            bgcolor: theme.palette.primary.dark,
                                        },
                                    }}
                                >
                                    {isSubmitting
                                        ? 'Submitting...'
                                        : 'Submit Request'}
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                )}
            </CardContent>
        </Card>
    )
}
